import { useEffect, useState } from "react";
import { Card, Form, Row, Col, Button, DatePicker, Tag } from "antd";
import { StyledSelect } from "../../planejamentoOperacional/components/ModalOrdemServicoMatriz/components/ModalCadastroOrdemServico/styles";
import useUpdateNotificacoes from "../hooks/useUpdateNotificacoes";

const { Item, useForm } = Form;

interface FiltersNotificacoesProps {
  data: any;
}

function FiltersNotificacoes({ data }: FiltersNotificacoesProps) {

  const [form] = useForm();

  const [horarioSelecionado, setHorarioSelecionado] = useState<string>();
  const [horariosSelecionados, setHorariosSelecionados] = useState<string[]>([]);
  const [mostrarDiaSemana, setMostrarDiaSemana] = useState(false);

  const { mutate, isLoading } = useUpdateNotificacoes();

  const adicionarHorario = () => {
    if (!horarioSelecionado) return;

    if (horariosSelecionados.includes(horarioSelecionado)) return;

    const novosHorarios = [...horariosSelecionados, horarioSelecionado].sort();

    setHorariosSelecionados(novosHorarios);
    setHorarioSelecionado(undefined);

    mutate({
      ...form.getFieldsValue(),
      horarios: novosHorarios,
    });
  }

  const removerHorario = (horario: string) => {
    const novosHorarios = horariosSelecionados.filter((item) => item !== horario);

    setHorariosSelecionados(novosHorarios);

    mutate({
      ...form.getFieldsValue(),
      horarios: novosHorarios,
    });
  }

  const formatarFrequencia = (frequencia: string) => {
    if (frequencia === "Diario") {
      return 1;
    }
    if (frequencia === "Semanal") {
      return 2;
    }
    return 3;
  }

  const formatarDiaSemana = (diaSemana: string) => {
    if (!diaSemana) return undefined;
    if (diaSemana === "Domingo") {
      return 1;
    }
    if (diaSemana === "Segunda") {
      return 2;
    }
    if (diaSemana === "Terca") {
      return 3;
    }
    if (diaSemana === "Quarta") {
      return 4;
    }
    if (diaSemana === "Quinta") {
      return 5;
    }
    if (diaSemana === "Sexta") {
      return 6;
    }
    return 7;
  }

  const statusOptions = [
    { value: true, label: "Ativo" },
    { value: false, label: "Inativo" },
  ];

  const frequenciaOptions = [
    { value: 1, label: "Diário" },
    { value: 2, label: "Semanal" },
    { value: 3, label: "Mensal" },
  ];

  const diaSemanaOptions = [
    { value: 1, label: "Domingo" },
    { value: 2, label: "Segunda-feira" },
    { value: 3, label: "Terça-feira" },
    { value: 4, label: "Quarta-feira" },
    { value: 5, label: "Quinta-feira" },
    { value: 6, label: "Sexta-feira" },
    { value: 7, label: "Sábado" },
  ];

  const horariosOptions = [
    { value: "00:00", label: "00:00" },
    { value: "00:30", label: "00:30" },
    { value: "01:00", label: "01:00" },
    { value: "01:30", label: "01:30" },
    { value: "02:00", label: "02:00" },
    { value: "02:30", label: "02:30" },
    { value: "03:00", label: "03:00" },
    { value: "03:30", label: "03:30" },
    { value: "04:00", label: "04:00" },
    { value: "04:30", label: "04:30" },
    { value: "05:00", label: "05:00" },
    { value: "05:30", label: "05:30" },
    { value: "06:00", label: "06:00" },
    { value: "06:30", label: "06:30" },
    { value: "07:00", label: "07:00" },
    { value: "07:30", label: "07:30" },
    { value: "08:00", label: "08:00" },
    { value: "08:30", label: "08:30" },
    { value: "09:00", label: "09:00" },
    { value: "09:30", label: "09:30" },
    { value: "10:00", label: "10:00" },
    { value: "10:30", label: "10:30" },
    { value: "11:00", label: "11:00" },
    { value: "11:30", label: "11:30" },
    { value: "12:00", label: "12:00" },
    { value: "12:30", label: "12:30" },
    { value: "13:00", label: "13:00" },
    { value: "13:30", label: "13:30" },
    { value: "14:00", label: "14:00" },
    { value: "14:30", label: "14:30" },
    { value: "15:00", label: "15:00" },
    { value: "15:30", label: "15:30" },
    { value: "16:00", label: "16:00" },
    { value: "16:30", label: "16:30" },
    { value: "17:00", label: "17:00" },
    { value: "17:30", label: "17:30" },
    { value: "18:00", label: "18:00" },
    { value: "18:30", label: "18:30" },
    { value: "19:00", label: "19:00" },
    { value: "19:30", label: "19:30" },
    { value: "20:00", label: "20:00" },
    { value: "20:30", label: "20:30" },
    { value: "21:00", label: "21:00" },
    { value: "21:30", label: "21:30" },
    { value: "22:00", label: "22:00" },
    { value: "22:30", label: "22:30" },
    { value: "23:00", label: "23:00" },
    { value: "23:30", label: "23:30" },
  ];

  useEffect(() => {
    if (data) {
      const frequencia = formatarFrequencia(data.frequencia);
      const diaSemana = formatarDiaSemana(data.diaSemana);
      form.setFieldsValue({ ...data, frequencia, diaSemana });
      setHorariosSelecionados(data.horarios);
      setMostrarDiaSemana(frequencia === 2 || frequencia === 3);
    }
  }, [data]);

  return (
    <Card style={{ margin: 16, borderRadius: 8 }}>
      <Form
        form={form}
        layout="vertical"
        onValuesChange={(changedValues, allValues) => {
          const frequencia = allValues.frequencia;
          setMostrarDiaSemana(frequencia === 2 || frequencia === 3);
          if ((frequencia === 2 || frequencia === 3) && !allValues.diaSemana) return;
          mutate({ ...allValues, horarios: horariosSelecionados });
        }}
      >
        <Row gutter={[8, 8]}>
          <Col span={8}>
            <Item label="Status Geral" name="ativo">
              <StyledSelect
                size="large"
                loading={isLoading}
                options={statusOptions}
              />
            </Item>
          </Col>
          <Col span={mostrarDiaSemana ? 4 : 8}>
            <Item label="Frequência de Envio" name="frequencia">
              <StyledSelect
                size="large"
                loading={isLoading}
                options={frequenciaOptions}
              />
            </Item>
          </Col>
          {mostrarDiaSemana && (
            <Col span={4}>
              <Item label="Dia da Semana" name="diaSemana">
                <StyledSelect
                  size="large"
                  loading={isLoading}
                  options={diaSemanaOptions}
                  placeholder="Dia da Semana"
                />
              </Item>
            </Col>
          )}
          <Col span={8}>
            <Item label="Último Disparo" name="dataUltimoDisparo">
              <DatePicker
                disabled
                size="large"
                placeholder="Último Disparo"
                style={{ borderRadius: 8, width: "100%" }}
              />
            </Item>
          </Col>
          <Col span={12}>
            <Item label="Horários de Envio">
              <div style={{ display: "flex", gap: 8 }}>
                <StyledSelect
                  size="large"
                  style={{ flex: 1 }}
                  loading={isLoading}
                  options={horariosOptions}
                  value={horarioSelecionado}
                  placeholder="Selecionar horário..."
                  onChange={(value: any) => setHorarioSelecionado(value)}
                />

                <Button
                  size="large"
                  type="primary"
                  onClick={adicionarHorario}
                  style={{
                    borderRadius: 8,
                    backgroundColor: "#12619C",
                  }}
                >Adicionar horário</Button>
              </div>
            </Item>

            <div style={{ marginTop: 8 }}>
              <span style={{ fontWeight: 600 }}>Horários configurados:</span>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 8 }}>
                {horariosSelecionados.map((horario) => (
                  <Tag
                    key={horario}
                    closable
                    onClose={(e) => {
                      e.preventDefault();
                      removerHorario(horario);
                    }}
                    style={{
                      backgroundColor: "#E5F2FC",
                      color: "#2585D1",
                      border: "none",
                      borderRadius: 20,
                      padding: "6px 12px",
                      fontSize: 14,
                      fontWeight: 600,
                      margin: 0,
                      display: "flex",
                      alignItems: "center",
                      gap: 4,
                    }}
                  >{horario}</Tag>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Form>
    </Card>
  );
}

export default FiltersNotificacoes;
